import Vue from 'vue';
import Confetti from '../vue/Confetti.vue';

const vm = new Vue({
    el: "#cp-nav-content",
    components: {
        'confetti': Confetti,
    },
    data: {
    },
    methods: {
    },
    mounted() {
    }
});
